import { defineComponent, type ExtractPropTypes, PropType } from 'vue';
import { createNamespace } from '@mts-fe/utils';

const [name, bem] = createNamespace('divider');

export type DividerContentPosition = 'left' | 'center' | 'right';

export const dividerProps = {
  dashed: Boolean,
  hairline: {
    type: Boolean,
    default: false,
  },
  vertical: Boolean,
  contentPosition: {
    type: String as PropType<DividerContentPosition>,
    default: 'center',
  },
};

export type DividerProps = ExtractPropTypes<typeof dividerProps>;

export default defineComponent({
  name,

  props: dividerProps,

  setup(props, { slots }) {
    return () => (
      <div
        role="separator"
        class={bem({
          dashed: props.dashed,
          hairline: props.hairline,
          vertical: props.vertical,
          [`content-${props.contentPosition}`]: !!slots.default && !props.vertical,
        })}
      >
        {!props.vertical && slots.default?.()}
      </div>
    );
  },
});
